/** Deteksi jabatan/departemen untuk akses menu & rute. */

export const HRD_POSITIONS = [
  'hrd',
  'hr',
  'staff hrd',
  'staf hrd',
  'human resources',
  'human resource',
  'personalia',
  'sumber daya manusia',
  'sdm',
];

export const HEAD_POSITIONS = [
  'head',
  'kepala',
  'head dept',
  'head department',
  'kepala divisi',
  'kepala bagian',
];

export const INTERN_POSITIONS = [
  'magang',
  'pkl',
  'intern',
  'internship',
  'praktik kerja lapangan',
  'praktek kerja lapangan',
];

export const GA_POSITIONS = [
  'ga',
  'general affair',
  'general affairs',
  'staff ga',
  'staf ga',
  'staff general affair',
  'urusan umum',
  'bagian umum',
];

/** Jabatan Finance saja (bukan match lewat nama divisi/departemen). */
export const FINANCE_POSITIONS = [
  'finance',
  'staff finance',
  'staf finance',
  'keuangan',
  'staff keuangan',
  'staf keuangan',
];

/** Jabatan Procurement / Pengadaan. */
export const PROCUREMENT_POSITIONS = [
  'procurement',
  'staff procurement',
  'staf procurement',
  'pengadaan',
  'staff pengadaan',
  'staf pengadaan',
  'purchasing',
  'staff purchasing',
  'staf purchasing',
];

/** Divisi / departemen Operasional. */
export const OPERASIONAL_POSITIONS = [
  'operasional',
  'operational',
  'ops',
  'divisi operasional',
  'departemen operasional',
];

const WORD_BOUNDARY_NEEDLES = new Set([
  'head',
  'kepala',
  'ga',
  'finance',
  'keuangan',
  'ops',
  'procurement',
  'pengadaan',
  'purchasing',
]);

export function normalizePositionText(value) {
  return String(value || '').trim().toLowerCase();
}

export function employeePositionBlob(employeeDetails) {
  return [
    employeeDetails?.position,
    employeeDetails?.jabatan,
    employeeDetails?.department,
    employeeDetails?.division,
    employeeDetails?.role,
  ]
    .map(normalizePositionText)
    .filter(Boolean)
    .join(' ');
}

/** Hanya field jabatan/posisi — dipakai akses kasbon Finance. */
export function employeeJabatanBlob(employeeDetails) {
  return [employeeDetails?.position, employeeDetails?.jabatan]
    .map(normalizePositionText)
    .filter(Boolean)
    .join(' ');
}

function blobMatchesNeedles(blob, allowedPositions = []) {
  if (!blob) return false;
  return (allowedPositions || []).some((allowed) => {
    const needle = normalizePositionText(allowed);
    if (!needle) return false;
    if (WORD_BOUNDARY_NEEDLES.has(needle) || needle.includes(' ')) {
      const escaped = needle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s+');
      return new RegExp(`\\b${escaped}\\b`).test(blob);
    }
    return blob.includes(needle);
  });
}

export function positionMatches(employeeDetails, allowedPositions = []) {
  return blobMatchesNeedles(employeePositionBlob(employeeDetails), allowedPositions);
}

export function jabatanMatches(employeeDetails, allowedPositions = []) {
  return blobMatchesNeedles(employeeJabatanBlob(employeeDetails), allowedPositions);
}

export function isHrdPosition(employeeDetails) {
  return positionMatches(employeeDetails, HRD_POSITIONS);
}

export function isGaPosition(employeeDetails) {
  return positionMatches(employeeDetails, GA_POSITIONS);
}

export function isFinancePosition(employeeDetails) {
  return jabatanMatches(employeeDetails, FINANCE_POSITIONS);
}

export function isProcurementPosition(employeeDetails) {
  return jabatanMatches(employeeDetails, PROCUREMENT_POSITIONS);
}

export function isOperasionalPosition(employeeDetails) {
  return positionMatches(employeeDetails, OPERASIONAL_POSITIONS);
}

/**
 * Jabatan lapangan Teknisi/Jointer — bukan Koordinator/Head.
 */
export function isTeknisiJabatan(employeeDetails) {
  const jabatan = employeeJabatanBlob(employeeDetails);
  const role = normalizePositionText(employeeDetails?.role);
  const blob = [jabatan, /^(teknisi|jointer)$/.test(role) ? role : '']
    .filter(Boolean)
    .join(' ');
  if (!blob) return false;
  if (/\b(koordinator|koord|head dept|head department|kepala divisi)\b/.test(blob)) return false;
  return /\b(teknisi|jointer)\b/.test(blob);
}

export function isFacilityComplaint(item) {
  return normalizePositionText(item?.category) === 'fasilitas';
}
